import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, error }) => ({
    '& .wrap': {
        position: 'relative'
    },

    input: {
        width: '100%',
        padding: '12px 25px 0 25px',
        height: 60,
        background: error
            ? `${theme.colors.blueLight} url(icons/error.svg) no-repeat right 20px center`
            : theme.colors.blueLight,
        border: 'none',
        borderRadius: 4,
        fontSize: toRem(14),
        color: error ? '#D32929' : theme.colors.white,

        [theme.breakpoints.up('lg')]: {
            fontSize: toRem(16),
            padding: '20px 25px 0 25px',
            height: 80
        },

        '&:focus': {
            outline: 'none',
            boxShadow: `0 0 0 2px ${theme.colors.goldDark}`
        },

        boxShadow: error ? `0 0 0 2px #D32929` : ''
    },

    label: {
        position: 'absolute',
        top: '50%',
        left: 25,
        transform: 'translateY(-50%)',
        fontSize: toRem(12),
        fontWeight: theme.typography.fontWeight.medium,
        color: error ? '#D32929' : theme.colors.white,
        transition: 'all 0.5s ease',

        [theme.breakpoints.up('lg')]: {
            fontSize: toRem(14)
        },

        '&.isActive': {
            top: 10,
            color: error ? '#D32929' : theme.colors.goldDark,
            transform: 'translateY(0)',

            [theme.breakpoints.up('lg')]: {
                top: 17
            }
        }
    },

    '& .inputError': {
        fontSize: toRem(10),
        color: '#D32929',
        fontStyle: 'italic',
        paddingLeft: toRem(20),
        paddingTop: toRem(5),

        '&:before': {
            content: '"*"'
        }
    }
})

export default style
